import { Layout as AntLayout } from "antd"
import SideNav from "./SideNav"
import Body from "./Body"
import Header from "./Header"
import MaintenanceBanner from "../components/MaintenanceBanner/MaintenanceBanner"

const AppLayout = ({ children }) => {
  return (
    <AntLayout className="app-shell">
      <a href="#main-content" className="skip-link">
        Skip to content
      </a>
      <SideNav />
      <AntLayout className="app-shell__main">
        <Header />
        <MaintenanceBanner />
        <Body>{children}</Body>
      </AntLayout>
    </AntLayout>
  )
}

export default AppLayout
